import React from "react";
import { Link } from "react-router-dom";
import ProductCard from "../components/ProductCard";
import { useWishlist } from "../context/WishlistContext";
import { useCart } from "../context/CartContext";
import "../assets/styles/Wishlist.css";

const Wishlist = () => {
  const { wishlistItems } = useWishlist();
  const { addToCart, isInCart } = useCart();

  const handleAddToCart = (product) => {
    addToCart(product);
  };

  return (
    <div className="wishlist-container">
      {wishlistItems.length > 0 ? (
        <div className="wishlist-grid">
          {wishlistItems.map((product) => (
            <div key={product.id} className="wishlist-item">
              <ProductCard product={product} />
              <button
                className={`add-to-cart-btn ${isInCart(product.id) ? 'in-cart' : ''}`}
                onClick={() => handleAddToCart(product)}
                disabled={isInCart(product.id)}
              >
                {isInCart(product.id) ? 'IN CART' : 'ADD TO CART'}
              </button>
            </div>
          ))}
        </div>
      ) : (
        <div className="empty-wishlist">
          <h2>Your Wishlist is Empty</h2>
          <p>Add items that you like to your wishlist</p>
          <Link to="/products" className="shop-now-btn">
            Shop Now
          </Link>
        </div>
      )}
    </div>
  );
};

export default Wishlist;
